import makeQuery from "@saleor/hooks/makeQuery";
import gql from "graphql-tag";

import { AddPopup } from "./types/AddPopup";

export const addPopupFragment = gql`
  fragment AddPopupFragment on AddPopup {
    id
    name
    addPcImage
    addMbImage
    addLink
    enable
  }
`;

export const addPopupDetailsFragment = gql`
  ${addPopupFragment}
  fragment AddPopupDetailsFragment on AddPopup {
    ...AddPopupFragment
    addpopupVariants {
      id
      sortOrder
      variant {
        id
        name
        sku
        skuName
        isPublished
        product {
          id
          name
        }
        thumbnail {
          url
        }
      }
    }
  }
`;

const addpopup = gql`
  ${addPopupDetailsFragment}
  query AddPopup {
    addpopup {
      ...AddPopupDetailsFragment
    }
  }
`;

export const useAddPopupQuery = makeQuery<AddPopup, null>(addpopup);
